'use client'
import { type FC } from 'react'
import { useParams } from 'next/navigation'
import { useTranslator } from '@/hooks'
import styled from 'styled-components'

const MESSAGE_TRANSLATION = {
  de: '<p>💫 Aicam war ein bahnbrechendes KI-Experiment von <a href="https://you.digital" target="_blank" rel="noopener noreferrer">Digital You</a> aus dem Jahr 2023 - damals noch reine Science-Fiction. Wir halten es aus nostalgischen Gründen 🥰 im „Museumsmodus“ online. </p>',
  en: '<p>💫 Aicam was a pioneer AI experiment by <a href="https://you.digital" target="_blank" rel="noopener noreferrer">Digital You</a> in 2023, when this was sci-fi. We keep it online in “museum mode” for nostalgic reasons 🥰.</p>',
  es: '<p>💫 Aicam fue un experimento pionero de IA creado por <a href="https://you.digital" target="_blank" rel="noopener noreferrer">Digital You</a> en 2023, cuando esto aún era ciencia ficción. Lo mantenemos online en “modo museo” por nostalgia 🥰.</p>',
  fr: '<p>💫 Aicam était une expérience d\'IA pionnière créée par <a href="https://you.digital" target="_blank" rel="noopener noreferrer">Digital You</a> en 2023, à l\'époque où tout cela relevait encore de la science-fiction. Nous la gardons en ligne en “mode musée” par pure nostalgie 🥰.</p>',
  it: '<p>💫 Aicam è stato un esperimento pionieristico di IA creato da <a href="https://you.digital" target="_blank" rel="noopener noreferrer">Digital You</a> nel 2023, quando tutto questo era ancora fantascienza. Lo manteniamo online in “modalità museo” per nostalgia 🥰.</p>',
  pt: '<p>💫 Aicam foi uma experiência pioneira de IA criada pela <a href="https://you.digital" target="_blank" rel="noopener noreferrer">Digital You</a> em 2023, quando isso ainda era ficção científica. Mantemos o site online em “modo museu” por nostalgia 🥰.</p>',
}

export const FormAuthLogin: FC = () => {
  const { lang } = useParams()
  const { t } = useTranslator()

  return (
    <>
      <div className='msg' dangerouslySetInnerHTML={{ __html: MESSAGE_TRANSLATION[lang as string || 'en'] }} />
      <GoBack href='/'>{t('commons.actions.go_back')}</GoBack>
    </>
  )
}

const GoBack = styled.a`
  display: block;
  text-align: center;
  background: none;
  width: 100%;
  color: var(--color-text);
  text-decoration: underline;
`
